import { formatReviewsCount, formatReviewsRating } from '@/common/app/utils/numberUtils';
import * as S from './ReviewBlock.styles';
import { IReview } from '@/entities/Activity/domain/Review.domain';
import { Rating } from '@/entities/Activity/ui/Rating';
import { TRatingStars } from '@/common/domain/Rating.domain';
import { TooltipOnClick } from '@/common/ui/containers/TooltipOnClick/TooltipOnClick';

type TReviewsBlockProps = {
    rating?: string | number;
    reviews?: IReview[];
    ratingStars?: TRatingStars;
    rateCount?: string | number;
    reviewsCnt?: string;
    emptyReviewsMsg?: string;
    tooltip?: string;
    onClick?: () => void;
    size?: 'medium';
    whiteMode?: boolean;
};

export const ReviewsBlock = ({
    rateCount,
    reviewsCnt,
    emptyReviewsMsg,
    reviews,
    ratingStars,
    rating,
    tooltip,
    onClick,
    size,
    whiteMode,
}: TReviewsBlockProps) => {
    const noReviews =
        (!rateCount || !+rateCount) && (!reviewsCnt || !+reviewsCnt) && !reviews?.length;

    if (noReviews) {
        if (emptyReviewsMsg && tooltip) {
            return (
                <TooltipOnClick description={tooltip}>
                    <S.NoReviews tooltip>{emptyReviewsMsg}</S.NoReviews>
                </TooltipOnClick>
            );
        }

        if (emptyReviewsMsg) {
            return <S.NoReviews>{emptyReviewsMsg}</S.NoReviews>;
        }

        return <></>;
    }

    const count = reviewsCnt || rateCount || reviews?.length?.toString() || '';
    const reviewsCountWithComma = formatReviewsCount(count.toString());
    const reviewRating = formatReviewsRating(rating?.toString());

    return (
        <S.Reviews size={size} whiteMode={whiteMode}>
            <S.RatingText data-test-id="Rating_text">{reviewRating}</S.RatingText>
            {!!ratingStars && <Rating rating={ratingStars} data-test-id="Rating_start" />}
            <S.RatingCount onClick={onClick} data-test-id="Rating_count">
                ({reviewsCountWithComma})
            </S.RatingCount>
        </S.Reviews>
    );
};
